import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import {
  getAllFailure,
  getAllRequest,
  getAllSuccess,
  getPincodeDetailsFailure,
  getPincodeDetailsRequest,
  getPincodeDetailsSuccess,
} from 'redux/slice/agency-onbording/CompanyName.slice';
import { CompanyNamePayload } from 'redux/types/CompanyName.type';
import { agencyOnboarding } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* handleGetAgencyCompanyName(
  action: PayloadAction<CompanyNamePayload>
): any {
  try {
    const { companyName, page } = action.payload;
    const response = yield HTTPClient.GetRequest(
      agencyOnboarding.GET_AGENCY_COMPANY_NAME(companyName, page)
    );
    if (response.status === 200) {
      yield put(getAllSuccess({ data: response.data, companyName }));
    }
  } catch (error) {
    yield put(getAllFailure('Something went wrong!'));
  }
}

function* handleGetPincodeDetails(action: any): any {
  try {
    const response = yield HTTPClient.GetRequest(
      agencyOnboarding.GET_DETAILS_FROM_PINCODE(action.payload)
    );
    if (response.status === 200) {
      yield put(getPincodeDetailsSuccess(response.data));
    }
  } catch (error) {
    yield put(getPincodeDetailsFailure('Something went wrong!'));
  }
}

export function* watchGetAgencyCompanyName() {
  yield takeLatest(getAllRequest.type, handleGetAgencyCompanyName);
  yield takeLatest(getPincodeDetailsRequest.type, handleGetPincodeDetails);
}
